import React from 'react'
import styled from '@emotion/styled'
import { DEFAULT_BORDER_STYLES, DEFAULT_FONT_STYLES, DEFAULT_THEME_COLORS } from 'css/theme'

export interface TagProps {
  primaryColor: string
}

const TagContainer = styled.span`
  display: flex;
  align-items: center;
  position: absolute;
  top: -1rem;
  right: 50%;
  z-index: 1;
  transform: translateX(50%);

  font-family: ${DEFAULT_FONT_STYLES['--theme-font--base-font-family']};
  font-size: ${DEFAULT_FONT_STYLES['--theme-font--tag-bold__font-size']};
  font-weight: ${DEFAULT_FONT_STYLES['--theme-font--tag-bold__font-weight']};
  line-height: ${DEFAULT_FONT_STYLES['--theme-font--tag-bold__line-height']};

  color: var(--classy-color__text, #333333);
  background-color: ${DEFAULT_THEME_COLORS['--theme-color--neutral-100']};
  padding: 0.25rem 0.5rem;
  border: ${DEFAULT_BORDER_STYLES['--theme--border-tag']};
  border-radius: ${DEFAULT_BORDER_STYLES['--theme--border-radius-xxxl']};
  text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
`

const TagContent = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  align-items: center;
`

const HeartIcon = styled.svg<{
  color: string
  width?: number
  height?: number
}>`
  fill: ${({ color }) => color || 'currentColor'};
  width: ${({ width }) => width || 12}px;
  height: ${({ height }) => height || 12}px;
  transition: all 0.2s ease-in-out;
`

const HeartIconContainer = ({ primaryColor }: { primaryColor: string }) => (
  <HeartIcon
    color={primaryColor}
    width={15}
    height={14}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 15 14"
  >
    <path d="M6.95832 3.5966L7.29167 3.98877L7.62502 3.5966C7.84932 3.33271 8.11408 3.13036 8.42214 2.98616C8.72952 2.84228 9.05119 2.77075 9.39167 2.77075C10.0138 2.77075 10.5109 2.97455 10.914 3.37761C11.317 3.78068 11.5208 4.27774 11.5208 4.89992C11.5208 5.20748 11.4692 5.50836 11.3649 5.80456C11.2634 6.09251 11.0773 6.42875 10.7905 6.81486C10.504 7.20051 10.1113 7.64486 9.60731 8.14889C9.10121 8.655 8.45783 9.25999 7.67574 9.96466C7.67565 9.96474 7.67557 9.96481 7.67548 9.96489L7.29167 10.309L6.90785 9.96489C6.90776 9.96481 6.90768 9.96474 6.90759 9.96466C6.1255 9.25999 5.48213 8.655 4.97603 8.14889C4.47199 7.64486 4.07935 7.20051 3.79287 6.81486C3.50605 6.42875 3.31991 6.09251 3.21848 5.80456C3.11414 5.50836 3.0625 5.20748 3.0625 4.89992C3.0625 4.27774 3.26629 3.78068 3.66936 3.37761C4.07243 2.97455 4.56949 2.77075 5.19167 2.77075C5.53215 2.77075 5.85382 2.84228 6.16119 2.98616C6.46926 3.13036 6.73401 3.33271 6.95832 3.5966Z" />
  </HeartIcon>
)

export const RecurringUpsellTag: React.FC<TagProps> = ({ primaryColor }) => (
  <TagContainer aria-hidden="true">
    <TagContent>
      <span>Higher impact</span>
      <HeartIconContainer primaryColor={primaryColor} />
    </TagContent>
  </TagContainer>
)

export default RecurringUpsellTag
